<mat-radio-group [formControl]="getFormControl()">
    <mat-radio-button value="female">{{'COMMON.FEMALE' | translate}}</mat-radio-button>
    <mat-radio-button value="male">{{'COMMON.MALE' | translate}}</mat-radio-button>
    <mat-radio-button [value]="getNotDefinedValue()">{{'COMMON.NOT_DEFINED' | translate}}
    </mat-radio-button>
</mat-radio-group>
